"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableOption = void 0;
const Colors_1 = require("../../Colors");
exports.TableOption = {
    sortIcon: {
        size: 20,
        color: Colors_1.Colors.grey,
    },
};
